import type { Channel } from '../types'
import { formatViews } from '../lib/format'
import { Avatar } from './Avatar'

type Props = {
  channel: Channel | null
  slug: string
  favorite: boolean
  onToggleFavorite: () => void
}

export function ChannelHeader({ channel, slug, favorite, onToggleFavorite }: Props) {
  const name = channel?.username ?? slug

  return (
    <header className="channel-header">
      <div className="channel-info">
        <Avatar src={channel?.profilePic} name={name} size={68} />
        <div className="channel-name">
          {name}
          {channel?.isLive && (
            <span className="live-pill">
              <span className="live-dot" /> Live
            </span>
          )}
        </div>
        <div className="channel-stats">
          <span>@{slug}</span>
          {channel && <span>{formatViews(channel.followers)} followers</span>}
          {channel?.verified && <span>Verified</span>}
          {channel?.isLive && channel.liveTitle && (
            <span style={{ color: 'var(--text-dim)' }}>{channel.liveTitle}</span>
          )}
        </div>
        <div className="channel-spacer" />
        <button
          type="button"
          className="btn btn-ghost"
          onClick={onToggleFavorite}
          title={favorite ? 'Unfavorite channel' : 'Favorite channel'}
        >
          {favorite ? '★ Favorited' : '☆ Favorite'}
        </button>
        <a className="btn" href={`https://destiny.gg/bigscreen#kick/${slug}`} target="_blank" rel="noreferrer">
          Open in DGG ↗
        </a>
      </div>
    </header>
  )
}
